import { cn } from "@/lib/utils"

export interface ShimmerProps {
  className?: string
}

export function Shimmer({ className }: ShimmerProps) {
  return <div className={cn("shimmer-bar rounded", className)} />
}
